import { Row, Col, Form, Select, Input, SelectOption } from "@ir/ui";

const DotfoodsFormContent = ({
  getIssueCategories,
  isDisputeTypesLoading,
  disputeTypeChildren,
  isCustomerDeduction,
}: {
  getIssueCategories: () => SelectOption[];
  isDisputeTypesLoading: boolean;
  disputeTypeChildren: SelectOption[];
  isCustomerDeduction: boolean;
}) => {
  return (
    <Row>
      <Col span={12} md={3}>
        <Form.Item name="disputeType" rules={[{ required: true, message: "Issue Category is required." }]} label="Issue Category">
          <Select
            maxMenuHeight={150}
            className="select-field"
            placeholder="Select"
            options={getIssueCategories()}
            isClearable={false}
            isLoading={isDisputeTypesLoading}
          />
        </Form.Item>
      </Col>
      <Col span={12} md={3}>
        <Form.Item name="disputeSubType" rules={[{ required: true, message: "Issue Description is required." }]} label="Issue Description">
          <Select
            maxMenuHeight={150}
            className="select-field"
            options={disputeTypeChildren}
            placeholder="Select"
            isDisabled={disputeTypeChildren.length === 0}
            isClearable={false}
          />
        </Form.Item>
      </Col>
      <Col span={12} md={3}>
        <Form.Item
          name="disputeAmount"
          dependencies={["totalAmount"]}
          rules={[
            { required: true, message: "Dispute Amount is required." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const totalAmount = getFieldValue("totalAmount");
                if (value && Number(totalAmount) && Number(value) > Number(totalAmount)) {
                  return Promise.reject(new Error("Dispute Amount cannot be greater than Total Amount."));
                }
                // two decimal places
                if (value && value.toString().split(".")[1]?.length > 2) {
                  return Promise.reject(new Error("Dispute Amount must have two decimal places."));
                }
                return Promise.resolve();
              },
            }),
          ]}
          label="Dispute Amount"
        >
          <Input type="number" step="0.01" placeholder="Enter dispute amount" />
        </Form.Item>
      </Col>
      <Col span={12} md={3}>
        <Form.Item
          name="totalAmount"
          dependencies={["disputeAmount"]}
          rules={[
            { required: true, message: "Total Amount is required." },
            () => ({
              validator(_, value) {
                if (value && value.toString().split(".")[1]?.length > 2) {
                  return Promise.reject(new Error("Total Amount must have two decimal places."));
                }
                return Promise.resolve();
              },
            }),
          ]}
          label="Total Amount"
        >
          <Input type={isCustomerDeduction ? "text" : "number"} placeholder="Invoice total amount" disabled={isCustomerDeduction} />
        </Form.Item>
      </Col>
    </Row>
  );
};
export default DotfoodsFormContent;
